export default __webpack_public_path__ + "static/media/RecipientMaster.bffdaf3a.xlsx";